module.exports = __webpack_public_path__ + "static/media/CF.e7f45d5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CF.svg
// module id = 221
// module chunks = 0